import {PlaceholderPage} from '@app/web-player/premium/premium-placeholder-page';
import {RouteObject} from 'react-router';

export const PREMIUM_SITE_PAGES = [
  {path: 'about', name: 'About'},
  {path: 'jobs', name: 'Jobs'},
  {path: 'news', name: 'For the Record'},
  {path: 'for-artists', name: 'For Artists'},
  {path: 'developers', name: 'Developers'},
  {path: 'advertising', name: 'Advertising'},
  {path: 'investors', name: 'Investors'},
  {path: 'vendors', name: 'Vendors'},
  {path: 'download', name: 'Free Mobile App'},
  {path: 'legal', name: 'Legal'},
  {path: 'legal/privacy-center', name: 'Privacy Center'},
  {path: 'legal/about-ads', name: 'About Ads'},
  {path: 'legal/accessibility', name: 'Accessibility'},
  {path: 'premium/terms', name: 'Premium Terms'},
  {path: 'premium/offer-terms', name: 'Offer Terms'},
  {path: 'premium/student-terms', name: 'Student Terms'},
  {path: 'premium/plans/individual', name: 'Premium Individual Signup'},
  {path: 'premium/plans/student', name: 'Premium Student Signup'},
  {path: 'premium/plans/duo', name: 'Premium Duo Signup'},
  {path: 'premium/plans/family', name: 'Premium Family Signup'},
] as const;

export const premiumSiteRoutes: RouteObject[] = [
  {
    path: 'support/article/:slug',
    lazy: () => import('@app/web-player/premium/support-article-page'),
  },
  {
    path: 'support/:lang',
    lazy: () => import('@app/web-player/premium/support-page'),
  },
  {
    path: 'support',
    lazy: () => import('@app/web-player/premium/support-page'),
  },
  {
    path: 'legal/:doc',
    lazy: () => import('@app/web-player/premium/legal-document-page'),
  },
  ...PREMIUM_SITE_PAGES.map(page => ({
    path: page.path,
    element: <PlaceholderPage name={page.name} />,
  })),
];
